import { render, staticRenderFns } from "./createSurvey.vue?vue&type=template&id=5d37b6cc&scoped=true"
import script from "./createSurvey.vue?vue&type=script&lang=js"
export * from "./createSurvey.vue?vue&type=script&lang=js"
import style0 from "./createSurvey.vue?vue&type=style&index=0&id=5d37b6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37b6cc",
  null
  
)

export default component.exports